
// const baseUrl = 'http://127.0.0.1:9889';
const baseUrl = 'https://case.gxcd-tech.com/case';
export default baseUrl;
